import React from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';

const NavigationImages = ({ depth }) => {

    const headerblocks = useSelector((state) => state.navigation.headerBlocks);
    const backgroundImage = useSelector((state) => state.navigation.headerBlockBackgroundUrl);

    if (headerblocks.length === 0 || depth > 1) {
        return null;
    }

    return <div className={`header-block ${depth === 1 ? 'header-block--desktop' : 'hide-desktop'}`}>
        {backgroundImage && (
            <img
                className="header-block__backgroundimg"
                src={backgroundImage}
                alt="Header megamenu background image"
            />
        )}

        <div className="header-block__images-container">
            {headerblocks.map((block, key) => (
                <div
									key={key}
                    className={`header-block__container ${
                        headerblocks.length < 3 &&
                        'header-block__container-fillh'
                    } ${
                        headerblocks.length < 2 &&
                        'header-block-container-fillw'
                    } ${
                        headerblocks.length > 4 &&
                        'header-block-container-displayNone'
                    }`}
                >
                    <div className="header-block__container__imgcontainer">
                        <img src={block.url} alt={block.alt}/>
                    </div>
                    {
                        (block.linkurl && block.buttonText) && <div className="header-block__container__button">
                            <a href={block.linkurl}>
                                {block.buttonText}
                            </a>
                        </div>
                    }

                </div>
            ))}
        </div>
    </div>;
};

export default NavigationImages;
